module.exports = __webpack_public_path__ + "img/bd9a96247cf2194211803f6389ee1286.bd9a9624.png";